import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Stack } from '@mui/material';
import { CustomerDevices } from './CustomerDevices';
import { GatewayList } from './GatewayList';
import { NetworkList } from './NetworkList';
import { ServiceControls } from './ServiceControls';
import { WideawakeServerInfo } from './WideawakeServerStats';
export const WideawakeView = () => {
    return (_jsxs(Stack, { marginBlockStart: 1, gap: 2, children: [_jsxs(Stack, { direction: "row", justifyContent: "space-between", gap: 2, children: [_jsx(WideawakeServerInfo, {}, "info"), _jsx(ServiceControls, {}, "controls")] }), _jsx(Divider, {}), _jsx(NetworkList, {}, "networks"), _jsx(Divider, {}), _jsx(GatewayList, {}, "gateways"), _jsx(Divider, {}), _jsx(CustomerDevices, {}, "devices")] }));
};
